/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import {
    CacheType,
    createObservableDataAction,
    IAction,
    IActionContext,
    IActionInput,
    ICreateActionContext
} from '@msdyn365-commerce/core';
import { getWebGroupBySearchTermAsync } from './DataActionExtension.g';
import { IWebGroupSearchResultEntity } from './DataServiceEntities.g';
import { GetQeuryFromUrl } from '../utilities';
import { GetCatalogIdFromContext } from '../utilities/get-catalog-id-from-context';

/**
 * GetWebgroupSearchResults Input Action
 */
export class GetWebgroupSearchResultsInput implements IActionInput {
    constructor() {}

    public getCacheKey = () => `WebgroupSearchResults`;
    public getCacheObjectType = () => 'WebgroupSearchResults';
    public dataCacheType = (): CacheType => 'none';
}

export const createGetWebgroupSearchResultsInput = (args: ICreateActionContext): IActionInput => {
    return new GetWebgroupSearchResultsInput();
};

export async function getWebgroupSearchResultsAction(
    input: GetWebgroupSearchResultsInput,
    ctx: IActionContext
): Promise<IWebGroupSearchResultEntity[]> {
    const searchTerm = GetQeuryFromUrl(ctx);
    if (!searchTerm) {
        throw new Error('No search term provided');
    }

    let catalogId = GetCatalogIdFromContext(ctx).toString();
    if (catalogId === '-1') {
        catalogId = '0';
    }

    //const apiSettings = Msdyn365.msdyn365Commerce.apiSettings;
    return getWebGroupBySearchTermAsync({ callerContext: ctx }, searchTerm, 1000, 1, catalogId)
        .then(data => {
            return data;
        })
        .catch(error => {
            ctx.telemetry.exception(error);
            ctx.trace('[get-webgroup-search-results] Unable to load serach results');
            throw new Error('[get-webgroup-search-results] Unable to load search results');
        });
}

export default createObservableDataAction({
    action: <IAction<IWebGroupSearchResultEntity[]>>getWebgroupSearchResultsAction,
    id: 'GetWebgroupSearchResults',
    input: createGetWebgroupSearchResultsInput
});
